<template>
  <div>
    <data-table
      :headers="headers"
      :url="url"
      title="Crypto Withdrawals"
      searchable
      ref="table"
      :fields="fields"
      :dateSort="true"
      @date-range-updated="(url) => (this.url = url)"
      @click:row="showWithdrawalDetails"
    >
      <template slot="item.amount" slot-scope="{ item }">
        {{ `${$options.filters.crypto(item.amount)} ${item.currency}` }}
      </template>
      <template slot="item.provider" slot-scope="{ item }">
        {{ item.provider | title }}
      </template>
    </data-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showArchived: false,
      selectedTab: "",
      url: "/api/v1/crypto/withdrawals",
      headers: {
        "crypto_transaction.user.full_name": "Name",
        "crypto_transaction.user.full_phone_number": "Phone number",
        amount: " Amount",
        provider: "Provider",
        destination_address: "Destination Address",
        "crypto_transaction.id": "Transaction Id",
        status: "Withdrawal Status",
        "crypto_transaction.crypto_sending_status": "Transaction Status",
      },
      fields: {
        status: { type: "title" },
        "crypto_transaction.crypto_sending_status": { type: "title" },
      },
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    showWithdrawalDetails({ id }) {
      // todo: get withdrawal details.
    },
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
    selectedTab: function (val) {
      // extract the first section of the url to avoid concatnating on existing type
      const url_section = this.url.split("?")[0];
      this.url = `${url_section}?${this.$refs.table.addParams(this.url, [
        { name: "type", value: val },
      ])}`;
    },
    showArchived: function (val) {
      const params = this.$refs.table.addParams(this.url, []);
      if (val) {
        this.url = `/api/v1/payments/all?${params}`;
      } else {
        this.url = `/api/v1/payments?${params}`;
      }
    },
  },
};
</script>
